// components/filters/TotalOOFilter.js
import React from "react";
import FilterBase from "../FilterBase";
import Input from "../../ui/Input";
import Space from "../../ui/Space";
import { FILTER } from "../../utils/Struct";
import Button from "../../ui/Button";
import DateField from "../../ui/DateField";
import { bm_date } from "../../utils/Utils";
import { ENUMS } from "../../utils/Enums";
import { drawPicker } from "../../popovers/Picker";
import { ROUTES } from "../../utils/Routes";

export default function ConditionOnly(props) {

    const { onSave = () => { }, onClose = () => { }, filter = {}, date = false, edit = false, inputParams = { number: true, maxLength: 3, width: 35 } } = props;

    const route = ROUTES.REPORTS.FILTER_EDIT;
    const { value = 1, text = "", text2 = "" } = filter;

    
    const fields = [
        { key: "comparison", value: "=", help: "= equal, < less, > greater  (PgUp to select)" },
        { include: true, label: "save", key: "save", value: "", help: "Press Enter to save" },
    ];

    const save = (tabs) => {
        const comparison = tabs.find(f => f.key === "comparison").value;
      
        const _f = {
            ...FILTER,
            type: value,
            comparison: comparison,
        }
        onSave(_f);
    }

    const drawSelect = (_value, _ref, _update, _index, _proceed) => {

        drawPicker({
            value: _value, title: "Select", closeable: true, height: 300, ref: _ref, route: route, close: () => { _ref.focus(); }, callback: (e) => {
                if (e) {
                    _update(_index, e);
                    setTimeout(() => {
                        _proceed(e)
                    }, 10)
                }
            }, offset: [0, 10],
            options: ENUMS.COMPARE
        })

    }


    return (
        <FilterBase fields={fields} onClose={() => onClose()} onSave={(tabs) => {
            save(tabs)
        }}>
            {({ editProps, update, tabs, proceed, refs, index }) => (
                <div>
                    <Space>
                        <span>{text}</span>
                        <Input {...editProps("comparison")} chars={[">", "<", "="]} onPageUp={(e) => drawSelect(e, refs?.current?.[index], update, index, proceed)} onFill={(e) => proceed(e)} maxLength={1} width={20} />
                        {(text2 && <span>{text2}</span>)}
                        <Button onClick={() => save(tabs)} {...editProps("save")} >Save</Button>
                        
                    </Space>
                </div>
            )}
        </FilterBase>
    );
}
